var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Macedonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M24,32c0.224,0,0.443-0.016,0.661-0.031l1.973,11.838c4.784-0.631,9.024-2.948,12.122-6.341 L30.234,29c0.193-0.245,0.37-0.495,0.536-0.76l9.851,6.881c1.83-2.73,2.995-5.938,3.291-9.396l-11.939-1.194 C31.984,24.354,32,24.177,32,24c0-0.177-0.016-0.354-0.026-0.531l11.939-1.194c-0.296-3.457-1.461-6.665-3.291-9.396l-9.851,6.881 c-0.167-0.266-0.344-0.521-0.536-0.76l8.522-8.466c-3.098-3.393-7.338-5.709-12.122-6.341l-1.973,11.838 C24.443,16.016,24.224,16,24,16s-0.443,0.016-0.661,0.031L21.366,4.193c-4.784,0.631-9.024,2.948-12.122,6.341L17.766,19 c-0.193,0.245-0.37,0.495-0.536,0.76l-9.851-6.881c-1.83,2.73-2.995,5.938-3.291,9.396l11.939,1.194C16.016,23.646,16,23.823,16,24 c0,0.177,0.016,0.354,0.026,0.531L4.087,25.725c0.296,3.457,1.461,6.665,3.291,9.396l9.851-6.881 c0.167,0.266,0.344,0.516,0.536,0.76l-8.522,8.466c3.098,3.393,7.338,5.709,12.122,6.341l1.973-11.838 C23.557,31.984,23.776,32,24,32z M18.667,24c0-2.948,2.385-5.333,5.333-5.333s5.333,2.385,5.333,5.333 c0,2.948-2.385,5.333-5.333,5.333S18.667,26.948,18.667,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M30.771,19.76l9.851-6.881c-0.558-0.833-1.191-1.608-1.865-2.346L30.234,19 C30.427,19.24,30.604,19.495,30.771,19.76z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M16,24c0-0.177,0.016-0.354,0.026-0.531L4.087,22.275C4.038,22.845,4,23.418,4,24 s0.038,1.155,0.087,1.725l11.939-1.194C16.016,24.354,16,24.177,16,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M30.234,29l8.522,8.466c0.674-0.738,1.307-1.513,1.865-2.346l-9.851-6.881 C30.604,28.505,30.427,28.755,30.234,29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M24.661,31.969C24.443,31.984,24.224,32,24,32s-0.443-0.016-0.661-0.031l-1.973,11.838 C22.23,43.921,23.105,44,24,44s1.77-0.079,2.634-0.193L24.661,31.969z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M32,24c0,0.177-0.016,0.354-0.026,0.531l11.939,1.194C43.962,25.155,44,24.582,44,24 s-0.038-1.155-0.087-1.725l-11.939,1.194C31.984,23.646,32,23.823,32,24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M24,16c0.224,0,0.443,0.016,0.661,0.031l1.973-11.838C25.77,4.079,24.895,4,24,4 s-1.77,0.079-2.634,0.193l1.973,11.838C23.557,16.016,23.776,16,24,16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M17.766,19l-8.522-8.466c-0.674,0.738-1.307,1.513-1.865,2.346l9.851,6.881 C17.396,19.495,17.573,19.245,17.766,19z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M17.229,28.24l-9.851,6.881c0.558,0.833,1.191,1.608,1.865,2.346L17.766,29 C17.573,28.755,17.396,28.505,17.229,28.24z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24,
    fill: "#ffeb3b",
    rx: 5.333,
    ry: 5.333,
    transform: "rotate(-9.213 24 23.996)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Macedonia);
export default __webpack_public_path__ + "static/media/icons8-macedonia.9cf3e0b81135777a9dad9e91f7da0a23.svg";
export { ForwardRef as ReactComponent };